export default {
    formatCurrency: function(x){
        return `$${Number(x.toFixed(1)).toLocaleString()}`
    }
}